import { UnderlyingInfo } from 'components/shared/UnderlyingInfo/UnderlyingInfo';
import { UnderlyingTag } from 'components/underlying-tag';
import type { CreditUnderlying } from 'models/underlying/credit';
import { FC } from 'react';

import { CodeCell } from '../../Common/Cells';

export interface CreditDataTableProps {
  underlying: CreditUnderlying;
}

export const CreditDataTable: FC<CreditDataTableProps> = ({ underlying }) => (
  <CodeCell.Data>
    <>
      <UnderlyingTag value={underlying} label={underlying.curveName} size="lg" isReadOnly />
      <UnderlyingInfo underlying={underlying} />
    </>
  </CodeCell.Data>
);
